export default function ExchangeRateNote({ locale, compact = false }: { locale: 'tr' | 'en'; compact?: boolean }) {
  if (locale !== 'tr') return null;
  return <div className={`exchange-rate-note ${compact ? 'exchange-rate-compact' : ''}`} data-exchange-note>
    <span>{compact ? 'Sabit TL gösterim fiyatı · ödeme USD' : 'TL tutarları sabit gösterim fiyatlarıdır; günlük kura göre değişmez. Ödeme ve cüzdan işlemleri ödeme ekranında belirtilen ABD doları tutarıyla yapılır. Bankanızın uyguladığı kur ve vergiler nedeniyle kartınıza yansıyan TL tutarı farklı olabilir.'}</span>
  </div>;
}
